import { ActionsOverlay } from 'component/actions-overlay';
import { HorizBox } from 'component/basics';
import { ActionPinComment, ActionUnpinComment } from 'feature/question/pin-comment';
import type { QuestionInstance } from 'structure/question/actions-overlay';
import { ActionClose, ActionOpen, ActionPreview } from 'structure/question/actions-overlay';
import { componentWithVariants, demoFile, variant } from 'system/demo';
import { useGlobalProperty } from 'util/datastore';

demoFile('component/actions-overlay');

type ActionsOverlayDemoProps = {
    demoType: 'comment' | 'space';
    commentKey?: string;
    question?: QuestionInstance;
};

function ActionsOverlayDemo({ demoType, commentKey = 'demo-comment' }: ActionsOverlayDemoProps) {
    const pins = useGlobalProperty('pinned_comments');
    const features = useGlobalProperty('features');

    if (demoType === 'comment') {
        const isPinned = pins?.[commentKey];
        const actions = isPinned ? [ActionUnpinComment] : [ActionPinComment];
        return (
            <HorizBox right>
                <ActionsOverlay actionArgs={{ commentKey }} actions={actions} />
            </HorizBox>
        );
    }

    if (demoType === 'space') {
        const question: QuestionInstance = {
            instanceKey: 'demo-question',
            structureKey: 'question',
        };
        const actions = features?.readonly ? [ActionPreview, ActionOpen] : [ActionPreview, ActionClose];
        return (
            <HorizBox right>
                <ActionsOverlay actionArgs={{ question }} actions={actions} />
            </HorizBox>
        );
    }

    return null;
}

componentWithVariants('ActionsOverlay', ActionsOverlayDemo, {}, [
    variant('Comment Actions', {
        args: { demoType: 'comment' } as const,
        state: { roles: ['Owner'], globals: { pinned_comments: { 'demo-comment': false } } },
    }),
    variant('Space Actions', {
        args: { demoType: 'space' } as const,
        state: { globals: { features: { readonly: false } } },
    }),
]);
